export default __webpack_public_path__ + "images/logo_vertical.575e37a29075df3703901408b2654ee0.png";